module.exports = __webpack_public_path__ + "static/media/28-iveco-mercedes.ed790193.jpg";